export default {
  title: 'Eccezioni al calendario',
  fields: {
    status: {
      label: 'Stato',
    },
    date: {
      label: 'Data',
    },
    description: {
      label: 'Motivo',
    },
    recurring: {
      label: 'Ricorrenza annuale',
    },
    created: {
      label: 'Creato',
      creator: 'da {{name}}',
    },
    updated: {
      label: 'Aggiornato',
    },
  },
  status: {
    closed: 'Chiuso',
    open: 'Aperto',
    paused: 'In pausa',
  },
  date: {
    all_day: 'Tutto il giorno',
    paused_until_rest_of_day: 'In pausa fino a fine giornata',
  },
  buttons: {
    pause_availability: '+ Sospendi disponibilità',
    close_availability: '+ Chiudi disponibilità',
    amend_availability: '+ Modifica disponibilità',
    sync_from_online_shop: 'Sincronizza da negozio online',
    close: 'Chiudi',
    delete: 'Elimina',
  },
  projects: {
    online_shop: 'Negozio online',
    reservations: 'Prenotazioni',
    storefront: 'Vetrina',
  },
  error_messages: {
    delete_failed: 'Eliminazione non riuscita. Riprova.',
  },
  toasts: {
    sync_success: 'Sincronizzazione completata',
    sync_error: 'Sincronizzazione eccezioni dal negozio online non riuscita. Riprova.',
  },
};
